import React from 'react';

export default function DollarSign({ className = '', title }) {
  return (

<svg
  viewBox="0 0 21 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  className={className}
>
  <path
    d="M3.8709 4.33601C4.25621 4.33601 4.56857 4.02366 4.56857 3.63834C4.56857 3.25303 4.25621 2.94067 3.8709 2.94067C3.48559 2.94067 3.17323 3.25303 3.17323 3.63834C3.17323 4.02366 3.48559 4.33601 3.8709 4.33601Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
  <path
    d="M6.19646 4.33601C6.58178 4.33601 6.89413 4.02366 6.89413 3.63834C6.89413 3.25303 6.58178 2.94067 6.19646 2.94067C5.81115 2.94067 5.49879 3.25303 5.49879 3.63834C5.49879 4.02366 5.81115 4.33601 6.19646 4.33601Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
  <path
    d="M8.52203 4.33601C8.90734 4.33601 9.2197 4.02366 9.2197 3.63834C9.2197 3.25303 8.90734 2.94067 8.52203 2.94067C8.13671 2.94067 7.82436 3.25303 7.82436 3.63834C7.82436 4.02366 8.13671 4.33601 8.52203 4.33601Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M20.1499 11.0802V3.17323C20.1499 1.50347 18.7964 0.149994 17.1266 0.149994C13.5527 0.149994 6.74716 0.149994 3.17323 0.149994C1.50347 0.149994 0.149994 1.50347 0.149994 3.17323V17.1266C0.149994 18.7964 1.50347 20.1499 3.17323 20.1499H10.1499C10.535 20.1499 10.8476 19.8373 10.8476 19.4522C10.8476 19.0671 10.535 18.7545 10.1499 18.7545H3.17323C2.2737 18.7545 1.54533 18.0261 1.54533 17.1266V3.17323C1.54533 2.2737 2.2737 1.54533 3.17323 1.54533H17.1266C18.0261 1.54533 18.7545 2.2737 18.7545 3.17323V11.0802C18.7545 11.4653 19.0671 11.7778 19.4522 11.7778C19.8373 11.7778 20.1499 11.4653 20.1499 11.0802Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.4522 5.73135H0.847663C0.46255 5.73135 0.149994 6.04391 0.149994 6.42902C0.149994 6.81414 0.46255 7.12669 0.847663 7.12669H19.4522C19.8373 7.12669 20.1499 6.81414 20.1499 6.42902C20.1499 6.04391 19.8373 5.73135 19.4522 5.73135Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M18.9471 19.0522L16.9927 16.2615C16.7722 15.9462 16.3369 15.8689 16.0215 16.0903C15.7062 16.3108 15.629 16.7461 15.8503 17.0615L17.8038 19.8522C18.0252 20.1675 18.4606 20.2447 18.7759 20.0233C19.0913 19.8029 19.1685 19.3675 18.9471 19.0522Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.5145 13.949C17.9257 13.0318 15.0485 11.3722 13.496 10.4764C13.068 10.2299 12.5369 10.2532 12.1322 10.536C11.7285 10.8187 11.5248 11.3108 11.6104 11.7964C11.9211 13.562 12.4969 16.8336 12.815 18.6401C12.9015 19.1359 13.2746 19.534 13.7639 19.6531C14.2532 19.7731 14.7666 19.5926 15.0736 19.1926L16.7052 17.0661L19.2615 16.2606C19.7424 16.1089 20.0875 15.6875 20.1424 15.1871C20.1973 14.6866 19.9508 14.2001 19.5145 13.949ZM18.5703 15.015L16.0755 15.802C15.9387 15.8448 15.8187 15.9285 15.7322 16.042L14.1397 18.1182L13.0308 11.8187L18.5703 15.015Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.3"
  />
</svg>


  );
}

